// extracted by mini-css-extract-plugin
export default {"description":"donation-complete_description_vDB1f","mainHeader":"donation-complete_mainHeader_bBnMk"};